var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('NavigationTop',{attrs:{"name":"Medioze","link":"/"}}),_c('section',{staticClass:"layout-section -space-top"},[_c('MediozeHeader'),_c('MediozeGallery')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }